import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProcoreUserConfig } from 'src/app/models/procoreUserConfig';
import { ClientService } from '../../services/client.service';
import { ContextService } from '../../services/context.service';

@Component({
	selector: 'app-configure-user',
	templateUrl: './configure-user.component.html',
	styleUrls: ['./configure-user.component.css']
})
export class ConfigureUserComponent implements OnInit {
	@Output() emitExit = new EventEmitter<any>();

	loading = true;

	procoreUserConfig: ProcoreUserConfig;

	showCommunicationExpanded = false;

	constructor(
		private clientService: ClientService,
		public contextService: ContextService,
	) { }

	ngOnInit() {
		this.loading = true;

		if (this.contextService.procoreUserConfig) {
			this.procoreUserConfig = this.contextService.procoreUserConfig;

			this.loading = false;
		} else {
			this.retrieveProcoreUserConfig();
		}
	}

	retrieveProcoreUserConfig() {
		this.clientService.getProcoreUserConfigByCompanyId(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreIsSandbox)
			.subscribe({
				next: (response) => {
					if (response) {
						this.procoreUserConfig = response;

						this.contextService.procoreUserConfig = this.procoreUserConfig;
					} else {
						this.procoreUserConfig.dropboxSignDefaultSubject = '';
						this.procoreUserConfig.dropboxSignDefaultMessage = '';
						this.procoreUserConfig.dropboxSignDefaultCC = '';

						this.contextService.procoreUserConfig = this.procoreUserConfig;
					}

					this.loading = false;
				},
				error: (err) => {
					this.procoreUserConfig.dropboxSignDefaultSubject = '';
					this.procoreUserConfig.dropboxSignDefaultMessage = '';
					this.procoreUserConfig.dropboxSignDefaultCC = '';

					this.contextService.procoreUserConfig = this.procoreUserConfig;

					this.loading = false;
				}
			});
	}

	cancelConfigurations() {
		this.emitExit.emit(false);
	}

	updateConfigurations() {
		this.loading = true;

		this.clientService.updateProcoreUserConfig(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreIsSandbox, this.procoreUserConfig)
			.subscribe({
				next: (response) => {
					this.contextService.procoreUserConfig = response;

					this.loading = false;
					this.emitExit.emit(true);

				},
				error: (err) => {
					this.loading = false;
					this.emitExit.emit(false);
				}
			});
	}
}
